import { render, staticRenderFns } from "./AddOrUpdateDieticiansNoteModal.vue?vue&type=template&id=6dea4b68&"
import script from "./AddOrUpdateDieticiansNoteModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateDieticiansNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateDieticiansNoteModal.vue?vue&type=style&index=0&id=6dea4b68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports